"use strict";

onDOMReady(function () {
  const payForm = document.getElementById('frm-payment-payForm');
  if (!payForm) {
    return;
  }

  /**
   * It means it's isFirstView.
   * @see GoogleTagManagerSubscriber.php
   * @see GoogleEcommercePageType.php
   */
  const isPurchasePage = window.hasOwnProperty('dataLayer') ? window.dataLayer[0]?.ecommercePageType === 'purchase' : false;
  if (!isPurchasePage) {
    return;
  }
  const buttons = document.getElementsByClassName('kvikymart-shopping-cart-submit');
  if (!buttons.length) {
    return;
  }
  const ajaxLoader = document.createElement('div');
  // noinspection InnerHTMLJS
  ajaxLoader.innerHTML = km_spinner.html;
  ajaxLoader.style.marginTop = '16px';
  const submitButton = buttons[0];
  submitButton.parentElement.append(ajaxLoader);
  payForm.addEventListener(`submit`, () => {
    submitButton.setAttribute(`disabled`, `true`);
  });
  let timeoutId = setTimeout(function () {
    submitButton.click();
  }, 1500);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
      ajaxLoader.remove();
      event.preventDefault(); // Prevent Safari from exiting full-screen.
    }
  });
});